import { isMeterAccessibility, type MeterAccessibility } from '@enmon/commons/lib/enmon/meters/accessibility';

export type AccessibilityState = MeterAccessibility[] | null;

export function isMeterAccessibilitySelection(value: unknown): value is MeterAccessibility[] {
  return Array.isArray(value) && value.length > 0 && value.every(isMeterAccessibilityValue);
}

export function readAccessibilitySelectionValue(value: string | undefined): AccessibilityState {
  if (!value) {
    return null;
  }

  const values = value
    .split(',')
    .map(item => item.trim())
    .filter(isMeterAccessibilityValue);

  return values.length > 0 ? values : null;
}

export function readAccessibility(value: unknown): AccessibilityState {
  if (Array.isArray(value)) {
    const values = value.filter(isMeterAccessibilityValue);

    return values.length > 0 ? values : null;
  }

  if (isMeterAccessibilityValue(value)) {
    return [value];
  }

  return null;
}

function isMeterAccessibilityValue(value: unknown): value is MeterAccessibility {
  return isMeterAccessibility(value);
}
